import { useFSPConfig, useParamId } from 'hooks';
import { useMemo } from 'react';

const useFSPConfigID = () => {
  const fspId = useParamId();
  const fspConfig = useFSPConfig(fspId, false);

  return useMemo(() => {
    return { fspId, id: fspConfig.id };
  }, [fspId, fspConfig.id]);
};

export default useFSPConfigID;
